import React from 'react';
import { ChevronDown, ArrowUpDown, ChevronUp } from 'lucide-react';

interface Props {
  columnKey: string;
  selectedColumn: string;
  sortDirection: 'ASC' | 'DESC';
}

function SortIcon({ columnKey, selectedColumn, sortDirection }: Props) {
  if (selectedColumn === columnKey) {
    return sortDirection === 'ASC' ? (
      <ChevronUp className='ml-2 h-4 w-4 inline-block' />
    ) : (
      <ChevronDown className='ml-2 h-4 w-4 inline-block' />
    );
  }

  return <ArrowUpDown className='ml-2 h-4 w-4 inline-block' />;
}

export default SortIcon;
